import {memo, PropTypes, shapeComponent, ShapeComponent, View} from "shared/base"
import React, {useEffect, useMemo} from "react"
import classNames from "classnames"
import FontAwesomeIcon from "react-native-vector-icons/FontAwesome"
import InputContainer from "./input-container"
import TextInput from "components/utils/text-input"
import {useForm} from "@kaspernj/api-maker/build/form"
import useInput from "@kaspernj/api-maker/build/use-input"

export default memo(shapeComponent(class ComponentsChalkyLayoutInput extends ShapeComponent {
  static defaultProps = {
    autoRows: false,
    required: false
  }

  static propTypes = {
    autoRows: PropTypes.bool.isRequired,
    dataSet: PropTypes.object,
    label: PropTypes.string,
    minimumRows: PropTypes.number,
    name: PropTypes.string,
    onChangeText: PropTypes.func,
    required: PropTypes.bool.isRequired,
    style: PropTypes.object,
    styles: PropTypes.object
  }

  setup() {
    const {inputProps} = useInput({props: this.props})
    const {defaultValue, name, value} = inputProps

    this.setInstance({form: useForm(), name})
    this.useStates({
      focus: false,
      valuePresent: () => Boolean(defaultValue) || Boolean(value)
    })

    // Set initial value in form
    useMemo(() => {
      if (this.form && name) {
        this.form.setValue(name, value || defaultValue || "")
      }
    }, [])

    useEffect(() => () => {
      if (this.form && name) {
        this.form.unsetValue(name)
      }
    }, [this.form, name])
  }

  containerProps() {
    const {containerProps, dataSet, ...containerRestProps} = this.props

    return Object.assign({}, containerRestProps, containerProps)
  }

  render() {
    const {autoRows, dataSet, icon, label, minimumRows, name: nameFromProps, onChangeText, required, style, styles, value, ...restProps} = this.props
    const {form, name} = this.tt
    const {focus, valuePresent} = this.s
    const {component, ...restDataSet} = dataSet || {}
    const actualDataSet = useMemo(() =>
      Object.assign(
        {component: classNames("utils/input", component), name},
        restDataSet
      )
    , [component, name, restDataSet])
    const textInputExtraProps = {}

    if (autoRows && this.props.multiline && !("rows" in this.props)) {
      // If no rows prop is passed, calculate the number of rows based on the value
      let rows = value ? value.split("\n").length : 1

      if (minimumRows && minimumRows > rows) {
        rows = minimumRows
      }

      if (!("whiteSpace" in actualStyle)) {
        actualStyle.whiteSpace = "nowrap"
      }

      textInputExtraProps.rows = rows
    }

    const actualStyle = useMemo(() => {
      const defaultStyle = {
        backgroundColor: "#f0f4fc",
        borderRadius: 8,
        paddingTop: 14,
        paddingRight: 24,
        paddingBottom: 14,
        paddingLeft: 24,
        color: "#2c2c96",
        fontSize: 16,
        outlineStyle: "none"
      }

      if (focus) {
        defaultStyle.backgroundColor = "#fff"
        defaultStyle.border = "1px solid #fff"
        defaultStyle.boxShadow = "0px 14px 40px 0px rgba(44, 44, 150, 0.2)"
      } else {
        defaultStyle.border = "1px solid #f0f4fc"
      }

      if (!focus && valuePresent) {
        defaultStyle.border = "1px solid #d6e2f9"
      }

      if (valuePresent) {
        defaultStyle.fontWeight = 600
      }

      const actualStyle = this.stylingFor("textInput", Object.assign(defaultStyle, style))

      if (icon) {
        actualStyle.paddingRight = 38
      }

      return actualStyle
    }, [icon, focus, valuePresent])

    return (
      <InputContainer {...this.props}>
        {icon &&
          <View
            style={{
              position: "absolute",
              right: 0,
              height: "100%"
            }}
          >
            <FontAwesomeIcon
              name={icon}
              style={{
                marginRight: 15,
                marginVertical: "auto",
                fontSize: 16,
                color: "#aaa"
              }}
            />
          </View>
        }
        <TextInput
          blurOnSubmit={form ? false : true} // eslint-disable-line no-unneeded-ternary
          dataSet={actualDataSet}
          onBlur={this.tt.onBlur}
          onChangeText={this.tt.onChangeText}
          onFocus={this.tt.onFocus}
          onSubmitEditing={this.tt.onSubmitEditing}
          placeholderTextColor="#6783b8"
          style={actualStyle}
          value={value}
          {...textInputExtraProps}
          {...restProps}
        />
      </InputContainer>
    )
  }

  onBlur = () => this.setState({focus: false})
  onFocus = () => this.setState({focus: true})

  onChangeText = (value) => {
    const {form, name} = this.tt
    const {onChangeText} = this.props

    this.setState({valuePresent: Boolean(value)})

    if (form && name) {
      form.setValue(name, value)
    }

    if (onChangeText) {
      onChangeText(value)
    }
  }

  onSubmitEditing = () => {
    const {form} = this.tt

    if (form) {
      this.form.submit()
    }
  }
}))
